import { render, staticRenderFns } from "./PermissionChangeModal.vue?vue&type=template&id=0b478310&"
import script from "./PermissionChangeModal.vue?vue&type=script&lang=js&"
export * from "./PermissionChangeModal.vue?vue&type=script&lang=js&"
import style0 from "./PermissionChangeModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports